<template>
    <div class="container">

        <Head v-if="meta.title" v-bind:meta="meta" :key="rkey"></Head>
        <Header></Header>
        <Navigation></Navigation>
        <Breadcrumbs v-if="breadcrumbs" v-bind:breadcrumbs="breadcrumbs"></Breadcrumbs>
        <PageContent v-if="this.$route.name != 'Exhibit'" />
        <ExhibitContent v-if="this.$route.name == 'Exhibit'" />
        <Footer></Footer>
    </div>
</template>

<script>
// libraries
import Vivus from 'vivus'
import axios from 'axios'


// components

import Head from '@/components/Common/Head.vue'
import Header from '@/components/Header/Header.vue'
import PageContent from '@/components/Page/PageContent.vue'
import ExhibitContent from '@/components/Page/ExhibitContent.vue'
import Navigation from '@/components/Common/Navigation.vue'
import Footer from '@/components/Footer/Footer.vue'
import Breadcrumbs from '@/components/Common/Breadcrumbs.vue'

// https://fizykoteka.ckc.uw.edu.pl/omeka/api/items?item_type=FizykotekaBiogram

// functions

export default {
    name: 'Page',
    props: ['apiCall'],
    components: {
        Head,
        Header,
        Navigation,
        PageContent,
        Breadcrumbs,
        Footer,
        ExhibitContent,
    },
    data() {
        return {
            page: Object,
            fbShareURL: 'https://www.facebook.com/sharer/sharer.php?u=' + window.location.href,
            meta: {
                url: window.location.href,
                description: '',
                title: "",
                og_type: 'website',
                og_image: ''
            },
            breadcrumbs: {
                'parent_title': '',
                'parent_uri': '',
                'self_title': '',
                'self_uri': window.location.href
            },
            rkey: Math.random()
        }
    },
    methods: {
        fetchData() {
            axios.get(
                // not using pagination
                this.$config.API_PATH + this.apiCall
            )
                .then((_resp) => {
                    console.log(_resp);
                    this.all_pages = _resp.data

                    if (_resp.data.length == 0) {
                        this.$router.push({
                            name: "NotFound",
                        });
                    }

                    if (this.$route.name != "Exhibit") {
                        let _params_slug = this.$route.params.slug
                        let _page_data
                        let _throw_error = true

                        console.log(this.$route.name);


                        // zmienic
                        this.all_pages.forEach(function (_page) {

                            if (_params_slug == _page.slug) {
                                _page_data = _page
                                _throw_error = false
                            }

                        })

                        //return

                        if (_throw_error) {
                            this.$router.push({
                                name: 'NotFound'
                            });
                        }

                        this.meta.description = _page_data.text.split('.')[0] + '.'
                        //_page_data.text = Sierotki.orphansFix(_page_data.text)

                        // uporzadkowac
                        this.page_title = _page_data.title
                        this.meta.title = _page_data.title
                        this.page = _page_data

                        this.breadcrumbs = {
                            'parent_title': null,
                            'parent_uri': null,
                            'self_title': '',
                            'self_uri': window.location.href
                        }

                    } else {
                        let _page_data = _resp.data[0]
                        //console.log(_page_data);
                        this.meta.description = _page_data.text.split('.')[0].replace(/<[^>]*>?/gm, '') + '.'
                        this.page_title = _page_data.title
                        this.meta.title = _page_data.title
                        this.page = _resp.data[0]
                        //this.page.text = Sierotki.orphansFix(this.page.text)
                        //this.page.content = Sierotki.orphansFix(this.page.content)

                        this.breadcrumbs = {
                            'parent_title': "Wystawy",
                            'parent_uri': '/wystawy',
                            'self_title': '',
                            'self_uri': window.location.href
                        }


                    }



                })
        }
    },
    destroyed() { },
    created() {
        this.fetchData()
    },
    watch: {
        '$route': 'fetchData',
        page: function () {
            this.rkey = Math.random()
            if (this.meta.og_image) {
                this.meta.og_image = this.page.ckc_cover_image
            } else {
                this.meta.og_image = require("@/assets/img/default.jpg")
            }

        }
    }
}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/components/Page/Page.vue